// extracted by css-extract-rspack-plugin
export default {"link":"_80564e09"};